import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Clock } from "lucide-react";

const SERVICES = [
  { slug: "laparoscopic-hernia-surgery-vijayawada", title: "Laparoscopic Hernia Surgery" },
  { slug: "laparoscopic-gallbladder-surgery-vijayawada", title: "Laparoscopic Gallbladder Surgery" },
  { slug: "laparoscopic-appendicectomy-vijayawada", title: "Laparoscopic Appendicectomy" },
  { slug: "laser-piles-treatment-vijayawada", title: "Laser Piles Treatment" },
  { slug: "laser-fissure-treatment-vijayawada", title: "Laser Fissure Treatment" },
  { slug: "laser-fistula-treatment-vijayawada", title: "Laser Fistula Treatment" },
  { slug: "thyroid-surgery-vijayawada", title: "Thyroid Surgery" },
  { slug: "varicose-veins-treatment-vijayawada", title: "Varicose Veins Treatment" },
  { slug: "breast-disease-treatment-vijayawada", title: "Breast Surgery" },
  { slug: "swellings-lipoma-abscess-cyst-vijayawada", title: "Excision of Swellings (Lipoma)" },
  { slug: "circumcision-vijayawada", title: "Circumcision" },
  { slug: "cellulitis-treatment-vijayawada", title: "Cellulitis Treatment" },
  { slug: "ulcer-treatment-vijayawada", title: "Ulcers Treatment" },
  { slug: "endoscopy-vijayawada", title: "Endoscopy" },
  { slug: "colonoscopy-vijayawada", title: "Colonoscopy" },
  { slug: "intestinal-surgeries-vijayawada", title: "Intestinal Surgeries" },
  { slug: null, title: "Chronic Wound Management" },
  { slug: null, title: "All General Surgical Procedures" },
];

const LINKS = [
  { label: "Home", to: "/" },
  { label: "About", to: "/#about" },
  { label: "Services", to: "/#services" },
  { label: "Health Blogs", to: "/blogs" },
  { label: "Testimonials", to: "/#testimonials" },
  { label: "FAQ", to: "/#faq" },
  { label: "Contact", to: "/#locations" },
];

export default function Footer() {
  return (
    <footer data-testid="footer" className="bg-navy text-white">
      <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-7xl py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-12">

          <div className="space-y-4">
            <img src="/images/footer-logo.webp" alt="Dr. Dileep Sunkavalli" className="h-20 md:h-24 w-auto" />
            <p className="text-slate-400 text-sm leading-relaxed">
              General, Laparoscopic and Laser Surgeon with over a decade of experience in
              Vijayawada. Delivering precision surgical care with a patient-first approach.
            </p>
            <p className="text-slate-500 text-xs">
              MBBS, MS (General Surgery), FMAS, FIAGES, FALS (Hernia), EFIAGES
            </p>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-white text-base mb-4">Quick Links</h4>
            <ul className="space-y-2">
              {LINKS.map(function(link) {
                return (
                  <li key={link.label}>
                    <Link to={link.to} className="text-slate-400 text-sm hover:text-teal transition-colors">
                      {link.label}
                    </Link>
                  </li>
                );
              })}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-white text-base mb-4">Our Services</h4>
            <ul className="space-y-2">
              {SERVICES.map(function(s) {
                return (
                  <li key={s.title}>
                    {s.slug ? (
                      <Link to={"/services/" + s.slug} className="text-slate-400 text-sm hover:text-teal transition-colors">
                        {s.title}
                      </Link>
                    ) : (
                      <span className="text-slate-400 text-sm">{s.title}</span>
                    )}
                  </li>
                );
              })}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-white text-base mb-4">Contact Info</h4>
            <ul className="space-y-3">
              <li>
                <a href="tel:+917075659696" className="flex items-start gap-2 text-slate-400 text-sm hover:text-teal transition-colors">
                  <Phone className="w-4 h-4 mt-0.5 flex-shrink-0" strokeWidth={1.5} />
                  <div>
                    <span>70756 59696</span>
                    <span className="block text-slate-500 text-xs">Kamineni Hospitals</span>
                  </div>
                </a>
              </li>
              <li>
                <a href="tel:+917842988596" className="flex items-start gap-2 text-slate-400 text-sm hover:text-teal transition-colors">
                  <Phone className="w-4 h-4 mt-0.5 flex-shrink-0" strokeWidth={1.5} />
                  <div>
                    <span>78429 88596</span>
                    <span className="block text-slate-500 text-xs">Divi Clinic</span>
                  </div>
                </a>
              </li>
              <li>
                <a href="mailto:drdileepsunkavalli@zohomail.in" className="flex items-center gap-2 text-slate-400 text-sm hover:text-teal transition-colors">
                  <Mail className="w-4 h-4 flex-shrink-0" strokeWidth={1.5} />
                  <span className="break-all">drdileepsunkavalli@zohomail.in</span>
                </a>
              </li>
              <li className="flex items-start gap-2 text-slate-400 text-sm">
                <MapPin className="w-4 h-4 mt-0.5 flex-shrink-0" strokeWidth={1.5} />
                <span>Kanuru and Penamaluru, Vijayawada</span>
              </li>
              <li className="flex items-start gap-2 text-slate-400 text-sm">
                <Clock className="w-4 h-4 mt-0.5 flex-shrink-0" strokeWidth={1.5} />
                <div>
                  <span>Mon-Sat: 9AM-5PM (Kamineni)</span>
                  <span className="block">Mon-Sat: 5PM-9PM (Divi)</span>
                </div>
              </li>
            </ul>
          </div>

        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-7xl py-5 flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="text-slate-500 text-xs">
            &copy; {new Date().getFullYear()} Dr. Dileep Sunkavalli. All rights reserved.
          </p>
          <p className="text-slate-600 text-xs">
            Laparoscopic Surgeon Vijayawada | General Surgeon Vijayawada
          </p>
        </div>
      </div>
    </footer>
  );
}
